export default __webpack_public_path__ + "static/media/secret-family-recipes.65d687b9.png";